/*

THIS REDUCER IS USED TO SAVE SELECTED OPTIONS IN THE SHIPPING METHOD 

*/

import * as types from '../actions/actionTypes';

export const urlParamsReducer = (state = {source: '', token: '', host: '', pickupOnly: false, id: '', location_id: null}, action) => {
    var newState = { ...state }
    switch (action.type) {
        case types.SET_URL_PARAMS:
            newState.source = (action.payload.source) ? action.payload.source : newState.source;
            newState.token = (action.payload.token) ? action.payload.token : newState.token;
            newState.host = (action.payload.host) ? action.payload.host : newState.host;
            newState.pickupOnly = (action.payload.pickupOnly && typeof action.payload.pickupOnly === 'string' && action.payload.pickupOnly.toLowerCase() === 'true') ? true : false;
            newState.id = (action.payload.id) ? action.payload.id : newState.id;
            newState.location_id = (action.payload.location_id) ? action.payload.location_id : newState.location_id;
            return newState;
            break; 
        default:
            return state;
    }
}
